import { h } from "omi";

import { IconProps } from "@/components";

export function TrashIcon({ width, height }: IconProps) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 20 20" fill="none">
      <path
        d="M13.3333 4.9998v-.6666c0-.9334 0-1.4002-.1816-1.7567a1.6669 1.6669 0 0 0-.7284-.7283c-.3565-.1817-.8232-.1817-1.7566-.1817H9.3333c-.9334 0-1.4001 0-1.7566.1817a1.6667 1.6667 0 0 0-.7284.7283c-.1816.3565-.1816.8233-.1816 1.7567v.6666m1.6666 4.5834v4.1666m3.3334-4.1666v4.1666M2.5 4.9998h15m-1.6667 0v9.3334c0 1.4001 0 2.1002-.2725 2.6349a2.4992 2.4992 0 0 1-1.0925 1.0926c-.5348.2725-1.2348.2725-2.635.2725H8.1667c-1.4002 0-2.1002 0-2.635-.2725a2.4997 2.4997 0 0 1-1.0926-1.0926c-.2724-.5347-.2724-1.2348-.2724-2.6349V4.9998"
        stroke="#B42318"
        stroke-width="1.6667"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
}
